export default __webpack_public_path__ + "static/media/TM.9e64e699.svg";